export const PROJECT_NAME = 'Lifky marketplace';
export const BASE_URL = 'https://api.lifky.com';
export const WEBSITE_URL = 'https://lifky.com';
export const api_url = BASE_URL + '/api/v1/';
export const api_url_admin = BASE_URL + '/api/v1/dashboard/admin/';
export const api_url_admin_dashboard = BASE_URL + '/api/v1/dashboard/';
export const IMG_URL = '';
export const MAP_API_KEY = 'AIzaSyDxpfSZBgWRVH5XB4bCx5_W1SSh4C7cvXE';
export const export_url = BASE_URL + '/storage/';
export const example = BASE_URL + '/';
export const defaultCenter = { lat: 40.7127281, lng: -74.0060152 };

export const VAPID_KEY = 'VAPID_KEY';
export const API_KEY = 'API_KEY';
export const AUTH_DOMAIN = 'AUTH_DOMAIN';
export const PROJECT_ID = 'PROJECT_ID';
export const STORAGE_BUCKET = 'STORAGE_BUCKET';
export const MESSAGING_SENDER_ID = 'MESSAGING_SENDER_ID';
export const APP_ID = 'APP_ID';
export const MEASUREMENT_ID = 'MEASUREMENT_ID';
export const DYNAMIC_LINK_DOMAIN = 'DYNAMIC_LINK_DOMAIN';
export const ANDROID_PACKAGE_NAME = 'ANDROID_PACKAGE_NAME';
export const IOS_BUNDLE_ID = 'IOS_BUNDLE_ID';

export const RECAPTCHASITEKEY = '6LdfU7gqAAAAAE_VVFheNO4Y0qqnh-3TPwJbf9-Q';

export const DEMO_SELLER = 107; // seller_id
export const DEMO_SELLER_UUID = '3566bdf6-3a09-4488-8269-70a19f871bd0'; // seller_id
export const DEMO_SHOP = 501; // seller_id
export const DEMO_DELIVERYMAN = 106; // deliveryman_id
export const DEMO_MANEGER = 114; // maneger_id
export const DEMO_MODERATOR = 297; // moderator_id
export const DEMO_ADMIN = 501; // administrator_id
export const DEMO_WAITER = 108; // waiter_id

export const SUPPORTED_FORMATS = [
  'image/jpg',
  'image/jpeg',
  'image/png',
  'image/webp',
];
